/** @file entityRoot: the transform node every joint mesh of one puppet instance hangs under. */
import { TransformNode } from '@babylonjs/core/Meshes/transformNode.js';
import type { Scene } from '@babylonjs/core/scene.js';

/** A fresh `TransformNode` named `name`; `placeEntityRoot` moves and scales it each frame. */
export function entityRoot(scene: Scene, name: string): TransformNode {
  return new TransformNode(name, scene);
}
